import React from 'react';

export const CLIENT_REPORTING_DATE_RANGES = ['1M', '6M', 'YTD', '1Y', 'All', 'Custom'];

export default function ClientReportingDateRangeControls({
  dateRange,
  onDateRangeChange,
  customDateRange,
  onCustomDateRangeChange,
  onRefresh,
  className = '',
}) {
  return (
    <div className={`vd-client-reporting-date-range${className ? ` ${className}` : ''}`}>
      <div className="vd-client-growth-control-cluster">
        <span className="vd-control-label">Date Range</span>
        <div className="vd-toggle-group">
          {CLIENT_REPORTING_DATE_RANGES.map((r) => (
            <button
              key={r}
              type="button"
              className={`vd-toggle ${dateRange === r ? 'active' : ''}`}
              onClick={() => onDateRangeChange(r)}
            >
              {r}
            </button>
          ))}
        </div>
      </div>

      {dateRange === 'Custom' && (
        <div className="vd-custom-dates">
          <input
            type="date"
            value={customDateRange.start}
            onChange={(e) => onCustomDateRangeChange({ ...customDateRange, start: e.target.value })}
          />
          <input
            type="date"
            value={customDateRange.end}
            onChange={(e) => onCustomDateRangeChange({ ...customDateRange, end: e.target.value })}
          />
        </div>
      )}

      {onRefresh ? (
        <button type="button" className="vd-btn secondary" onClick={onRefresh}>Refresh</button>
      ) : null}
    </div>
  );
}
